export default {
    setRepeats(state, repeats) {
        state.repeats = repeats;
    },
    setUpcomingRepeats(state, repeats) {
        state.upcomingRepeats = repeats;
    },
    setActiveRepeat(state, activeRepeat) {
        state.activeRepeat = activeRepeat;
    },
    setManageRepeatDialog(state, status) {
        state.manageRepeatDialog = status;
    },
    setManageDeleteRepeatDialog(state, status) {
        state.deleteRepeatDialog = status;
    },
    setUpcomingRepeatsDialog(state, status) {
        state.upcomingRepeatsDialog = status;
    }
}
